/*eslint-disable */
import Vue from 'vue'
import PingPong from './pingpongloader.vue'
var ComponentClass = Vue.extend(PingPong)
var instance = new ComponentClass()
instance.$mount()
const checkp = document.querySelector('body').appendChild(instance.$el)
Vue.prototype.$pingpong = instance
var pingVM = new Vue(instance)



// WEBPACK FOOTER //
// ./src/components/views/pingpong.js